<template>
  <div
    class="index-container"
    id="index-container"
    style="background-color: #eeeeee"
  >
    <top-bar :showBack="true" @back="$router.go(-1)" title="青听北疆"></top-bar>
    <div style="height: calc(100vh - 60px);overflow-y: auto">
      <div class="goid-page" v-if="gridDate">
        <div
          v-for="(item, index) in gridDate"
          :key="index"
          @click="gridCkick($event, item)"
          class="grid-item"
        >
          <div class="flex-column justify-content-start page-context">
            <img :src="item.img" style="width:100%;" />
          </div>
        </div>
      </div>
    </div>
    <img style="width: 100%;" :src="bn" alt="">
    <div style="width: 100%;height: 50px"></div>
  </div>
</template>

<script>
import topBar from "../top-bar/index";
import grid1 from "@/assets/images/qingtingbeijiang/lt.png";
import grid2 from "@/assets/images/qingtingbeijiang/rt_1.png";
import grid3 from "@/assets/images/qingtingbeijiang/ln.png";
import grid4 from "@/assets/images/qingtingbeijiang/rn.png";
import bn from "@/assets/images/qingtingbeijiang/bn.png";

export default {
  name: "idnex",
  components: { topBar },
  data() {
    return {
      bn: bn,
      gridDate: [
        {
          img: grid1,
          path: "/qingTingBeiJiangInput",
          type: "A"
        },
        {
          img: grid2,
          path: "/qingTingBeiJiangInput",
          type: "B"
        },
        {
          img: grid3,
          path: "/qingTingBeiJiangInput",
          type: "C"
        },
        {
          img: grid4,
          path: undefined,
          type: "D"
        }
      ]
    };
  },
  created() {
    this.route = this.$route.query;
  },
  mounted() {},
  destroyed() {},
  methods: {
    gridCkick($event, item) {
      if (item.path) {
        this.$router.push({ path: item.path + "?type=" + item.type });
      } else {
        this.$tip({
          message: "敬请期待"
        });
      }
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/flex.css";

.label {
  margin-top: 5px;
  color: #000000;
  font-weight: 500;
  background-color: #ffffff;
  font-size: 0.25rem;
  margin-left: 10px;
}

.label em {
  display: inline-block;
  width: 0.07rem;
  height: 0.26rem;
  border-radius: 0.035rem;
  background: #0c80ff;
  float: left;
  margin-right: 5px;
}

.page-context {
  font-weight: 600;
  font-size: 0.2rem;
}

.goid-page {
  margin: 0 10px;
  padding: 10px;
  height: 10rem;
  width: calc(100% - 20px);
  /*// padding: .86rem 0 .66rem 0;*/
  /*// background-color: #007aff50;*/
  display: grid;
  grid-template-columns: calc(50% - 5px) calc(50% - 5px);
  /*// grid-template-columns: repeat(auto-fill, 49%)*/
  grid-gap: 10px;
  grid-template-rows: calc(50% - 5px) calc(50% - 5px);
}

.grid-item {
  background-repeat: no-repeat;
  background-size: 100% auto;
}

.index-container {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
